import { Link } from 'react-router-dom';
import { BrandLogo } from '../../components/BrandLogo';
import { HelpTip } from '../../components/HelpTip';
import { env } from '../../lib/env';

export function HomePage() {
  const cloudReady = Boolean(env.supabaseUrl && env.supabasePublishableKey);
  return (
    <main className="app-main stack">
      <BrandLogo />
      <div>
        <div className="eyebrow">Adaptive · Mastery · Daily Learning</div>
        <h1>BelajarKu</h1>
        <p className="muted">Platform belajar multi-subjek dengan progression berbasis kemampuan, worksheet digital/print, history siswa, dan tutor-guided mastery.</p>
      </div>
      <HelpTip>{cloudReady ? 'Build ini terhubung ke Supabase. Masuk menggunakan akun BelajarKu sesuai role.' : 'Mode local preview aktif karena Supabase belum dikonfigurasi.'}</HelpTip>
      {cloudReady ? (
        <section className="card">
          <h2>Mulai</h2>
          <p className="muted">Siswa, tutor, orang tua, dan admin menggunakan akun masing-masing. Hak akses ditentukan oleh Student Record dan role.</p>
          <Link className="btn btn--primary btn--large" to="/login">Masuk ke BelajarKu</Link>
        </section>
      ) : (
        <section className="role-links">
          {[
            ['/student', 'Murid', 'Belajar hari ini, Ink, progres'],
            ['/teacher', 'Guru', 'Monitor murid dan mastery'],
            ['/parent', 'Orang Tua', 'Progres dan laporan'],
            ['/admin', 'Admin', 'Kurikulum dan operasional'],
          ].map(([to, title, desc]) => (
            <Link key={to} to={to} className="role-link">
              <article className="card"><h2>{title}</h2><p className="muted">{desc}</p></article>
            </Link>
          ))}
        </section>
      )}
    </main>
  );
}
